import React, { useState, useEffect } from 'react';
import {
  Alert, Box, Container, Divider, Skeleton, Snackbar,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// import moment from 'moment';
import { FmdGoodOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Images from '../../../Configs/images';
import ROUTES from '../../../Configs/routes';
import { getRequests } from '../../../Redux/Models/request';
import { getUserData } from '../../../Utils/storages';

export default function TrackingProgress({
  classes, data, isLoading, error, message,
}) {
  const dispatch = useDispatch();
  const userData = getUserData();
  const { t } = useTranslation();

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        severity: 'error',
        message: `Something went wrong, ${message}`,
      });
    }
  }, [error]);

  useEffect(() => {
    dispatch(getRequests(userData.id));
  }, []);

  const renderListProgress = () => {
    if (isLoading) {
      return (
        <Box className="mt-3">
          {new Array(2).fill(1).map((e, index) => (
            <Box className="tracking-box" key={index} mb={1}>
              <Skeleton variant="rectangular" width={84} height={22} style={{ borderRadius: 11 }} />
              <div className="flex space-between mt-2">
                <div style={{ width: '65%' }}>
                  <Skeleton variant="text" width="100%" />
                  <Skeleton variant="text" width="60%" />
                </div>
                <div>
                  <Skeleton variant="text" width={80} />
                  <Skeleton variant="text" width={80} />
                </div>
              </div>
            </Box>
          ))}
        </Box>
      );
    } if (data.length) {
      return (
        <Box className="mt-3">
          {data.map((history) => (
            <Box
              key={history.id}
              p={1.5}
              boxShadow="1px 1px 2px rgba(0, 0, 0, 0.02)"
              border="1px solid #F5F6F8"
              borderRadius="10px"
              display="flex"
              alignItems="flex-start"
              gap={1.5}
              mb={1}
            >
              <img alt={history.type} src={history.type === 'Request In' ? Images.OenoIn : Images.OenoOut} />
              <Box>
                <Box>
                  <div className="s-12 weight-700">{history.status}</div>
                  <div className="s-10">
                    {history.pickup_address?.name}
                    {' '}
                    ・
                    {' '}
                    {history.pickup_address?.city}
                    ,
                    {' '}
                    {history.pickup_address?.province}
                    ,
                    {' '}
                    {history.pickup_address?.country}
                  </div>
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box display="flex" alignItems="center" gap={0.5}>
                  <FmdGoodOutlined sx={{ fontSize: 12 }} />
                  <div className="weight-600 s-10">
                    {history.pickup_address?.label}
                    ,
                    {' '}
                    {history.pickup_address?.address}
                    ,
                    {' '}
                    {history.pickup_address?.city}
                    ,
                    {' '}
                    {history.pickup_address?.province}
                    ,
                    {' '}
                    {history.pickup_address?.country}
                    ,
                    {' '}
                    {history.pickup_address?.postal_code}
                  </div>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      );
    }
    return (
      <Box className="center mt-4">
        <img src={Images.NoResult} alt="No result" />
        <div className="mt-3 height-14">
          <div>No available tracking progress right now,</div>
          <div>
            start tracking by
            {' '}
            <strong>Request</strong>
            {' '}
            saving items
          </div>
        </div>
      </Box>
    );
  };

  return (
    <section className={`${classes.root}`}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Container>
        <div className="flex space-between align-items-center">
          <div>
            <div className="weight-700">
              {t('homePage.reqProgress')}
            </div>
            <div className="s-10">
              {t('homePage.reqProgressCount', { count: data.length || '0' })}
            </div>
          </div>
          <Link to={ROUTES.history()} className="link mute s-12 weight-500">{t('common.more')}</Link>
        </div>
        {renderListProgress()}
      </Container>

    </section>
  );
}
